import Aside from './Aside.vue'
import Breadcrumb from './Breadcrumb.vue'
import Callout from './Callout.vue'
import Footer from './Footer.vue'
import Header from './Header/Header.vue'
import Switch from './Switch.vue'
import Sidebar from './Sidebar/Sidebar.vue'

export {
  Aside,
  Breadcrumb,
  Callout,
  Sidebar,
  Footer,
  Header,
  Switch
}



// WEBPACK FOOTER //
// ./src/components/index.js